import lb from '@/lib/loopback';


export function findSegmentos(settings = {}) {
  return lb
    .find('/Segmentos/', settings);
}

export default {
  findSegmentos,
};
